// extracted by mini-css-extract-plugin
export var chevronIcon = "_b6-2";
export var teamName = "_b6-1";
export var teamSwitcherButton = "_b6-0";